export default "__VITE_ASSET__S5CI_GU9__"